import { render, staticRenderFns } from "./WeekSchedule.vue?vue&type=template&id=d149f13c&scoped=true&"
import script from "./WeekSchedule.vue?vue&type=script&lang=js&"
export * from "./WeekSchedule.vue?vue&type=script&lang=js&"
import style0 from "./WeekSchedule.vue?vue&type=style&index=0&id=d149f13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d149f13c",
  null
  
)

export default component.exports